import gatorProtectBR from './gatorProtect.br';
import gatorProtectMX from './gatorProtect.mx';
import gatorProtectCL from './gatorProtect.cl';
import gatorProtectCO from './gatorProtect.co';

const gatorProtect = {
  BR: gatorProtectBR,
  MX: gatorProtectMX,
  CL: gatorProtectCL,
  CO: gatorProtectCO,
};

export default gatorProtect;
